import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Card, CardBody, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import axios from 'axios';
import { BASE_URL } from "../../../../constants";
import { IoIosDocument } from "react-icons/io";
import { FaCalendar, FaChartArea, FaTimes } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";

function ComparisonReport() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [errMsg, setErrMsg] = useState(null);
	const [properties, setProperties] = useState([]);
	const [selectedProperty, setSelectedProperty] = useState(null);
	const [inspections, setInspections] = useState([]);
	const [selectedIds, setSelectedIds] = useState([null, null]);
	const [selectedInspections, setSelectedInspections] = useState([null, null]);
	const [viewItemImage, setViewItemImage] = useState(null);
	const [isExporting, setIsExporting] = useState(false);
	const location = useLocation();

	const viewInspectionId = (id && id !== null && id !== '') ? id : null;
	console.log('id', {id, viewInspectionId})

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/property/all`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setProperties(data.result.map((property) => ({
							name: property.name,
							id: property.id
						})));

						if (viewInspectionId !== null) {

							fetch(`${BASE_URL}/reports/comparison/specific-report/${viewInspectionId}`, {
								headers: {
									Authorization: `Bearer ${token}`
								}
							})
								.then(response => response.json())
								.then(data => {
									if (data.status) {
										setSelectedProperty(data.result.property_id);
										setSelectedIds([data.result.inspection_1, data.result.inspection_2]);
										getInspectionDetails(data.result.inspection_1, 0);
										getInspectionDetails(data.result.inspection_2, 1);
									}
									else {
										console.error("Error: Unable to fetch report data.");
									}
								})
								.catch(error => console.error("Error fetching data:", error));
						}
					}
					else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);

	useEffect(() => {
		setInspections([]);
		if (!location.state) {
			setSelectedIds(prev => {
				return prev.map(() => null);
			});
			setSelectedInspections(prev => {
				return prev.map(() => null);
			});
		}

		if (selectedProperty) {
			const token = localStorage.getItem('token');
			if (token) {
				fetch(`${BASE_URL}/dropdown/inspections?property_id=${selectedProperty}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
					.then(response => response.json())
					.then(data => {
						if (data.status) {
							setInspections(data.result.map((inspection) => ({
								label: `${formatInspectionActivity(inspection.activity)} - ${new Date(inspection.inspection_date).toLocaleDateString('en-US')}`,
								id: inspection.id
							})));
						}
						else {
							console.error("Error: Unable to fetch inspection data.");
						}
					})
					.catch(error => console.error("Error fetching data:", error));
			} else {
				console.error("Error: Authorization token is missing.");
			}
		}

	}, [selectedProperty])

	useEffect(() => {
		if (location.state){
			console.log("Location: ", location.state);
			if (location.state.property_id) {
				setSelectedProperty(location.state.property_id);
			}

			if (location.state.inspection_id) {
				setSelectedIds([location.state.inspection_id, null]);
				getInspectionDetails(location.state.inspection_id, 0);
			}
		}
	}, [location.state])

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const getStatusColor = (status) => {
		switch (status) {
			case 'NEW':
				return '#34b4eb';
			case 'SATISFACTORY':
				return '#03a631';
			case 'DAMAGE':
				return '#bd060f';
			case 'ATTENTION':
				return '#e6a800';
			case 'NOT_AVAILABLE':
				return '#e68519';
			default:
				return '#000';
		}
	};

	const formatStatus = (status) => {
		switch (status) {
			case 'NEW':
				return ['N', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
			case 'SATISFACTORY':
				return ['-', ' ', 'S', ' ', '-', ' ', '-', ' ', '-'];
			case 'DAMAGE':
				return ['-', ' ', '-', ' ', 'D', ' ', '-', ' ', '-'];
			case 'ATTENTION':
				return ['-', ' ', '-', ' ', '-', ' ', '!', ' ', '-'];

			case 'NOT_AVAILABLE':
				return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', 'N/A'];
			default:
				return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
		}
	};

	const renderFormattedStatus = (status) => {
		const formattedStatus = formatStatus(status);
		return (
			<span>
				{formattedStatus.map((char, index) => (
					<span key={index} style={{ color: getStatusColor(status), fontSize: '18px' }}>
						{char}
					</span>
				))}
			</span>
		);
	};

	const getInspectionDetails = (id, index) => {
		if (id == null || id == "") {
			setErrMsg("Please select inspection");
			return;
		}
		setErrMsg(null);
		setSelectedInspections(prev => {
			const prevReports = [...prev];
			prevReports[index] = null;
			return prevReports;
		})

		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/inspection/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						const formattedInspection = { ...data.result };
						formattedInspection.created_at = new Date(data.result.created_at).toLocaleDateString('en-US');
						
						setSelectedInspections(prev => {
							const prevReports = [...prev];
							prevReports[index] = formattedInspection;
							return prevReports;
						})
					} else {
						console.error("Error: Unable to fetch inspections data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		}
	}

	const handleSubmit = () => {
		if (!selectedProperty) {
			setErrMsg("Please select a property.");
			return;
		}

		if (selectedIds[0] == null || selectedIds[0] == "") {
			setErrMsg("Please select first inspection.");
			return;
		}
		if (selectedIds[1] == null || selectedIds[1] == "") {
			setErrMsg("Please select second inspections.");
			return;
		}
		
		setErrMsg(null);
		const token = localStorage.getItem('token');
		if (!token) {
			setErrMsg("Authorization token is missing.");
			return;
		}
		const data = {
			propertyId: selectedProperty,
			inspection_1: selectedIds[0],
			inspection_2: selectedIds[1],
		};

		fetch(`${BASE_URL}/reports/comparison/add`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then(data => {
				if (data.status) {
					alert(data.message)
					navigate(`/comparison-report`);
				} else {
					setErrMsg(data.message || "Failed to create deposit report.");
				}
			})
			.catch(error => {
				console.error("Error creating deposit report:", error);
				setErrMsg("An error occurred while creating the deposit report.");
			});
	}

	const handleGenerateReport = async () => {
		if (!viewInspectionId) return;

		const token = localStorage.getItem('token');

		if (!token) {
			console.error('Error: Authorization token is missing.');
			return;
		}

		try {
			setIsExporting(true)
			const response = await fetch(`${BASE_URL}/reports/comparison/export/${viewInspectionId}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			setIsExporting(false)
			const data = await response.json();
			console.log(data, 'response');

			if (data.status) {
				const newTab = window.open(data.result, '_blank');

				if (newTab) {
					newTab.document.title = 'Comparison Report';
				} else {
					console.error('Failed to open new tab');
				}
			} else {
				setErrMsg(data.message);
			}

		} catch (error) {
			console.error('Error generating PDF:', error);
			setErrMsg(error.message);
		}
	};

	// console.log("Selected Inspections: ", selectedInspections);
	return (
		<div className="content">
			<Row>
				<Col xs="6">
					<h4 className="mt-0">Comparison Report</h4>
				</Col>

				{(viewInspectionId != null) ? (
					<Col className="text-end">
						{/* <Button color="secondary" type="button" >Run Deposit Report (not important)</Button> */}
						<Button color="primary" type="button" disabled={isExporting} onClick={handleGenerateReport} style={{width: 200}} >{isExporting ? 'Exporting...' : 'Export Report'}</Button>
					</Col>
				) : null}
			</Row>

			<Card>
				<CardBody>
					{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

					<Row className="mb-4">
						<Col md={4}>
							<FormGroup>
								<Label>Property</Label>
								<Input type="select" name="type" id="type" value={selectedProperty} disabled={(viewInspectionId !== null)} onChange={(e) => setSelectedProperty(e.target.value)}>
									<option value="">Select Property</option>
									{properties.map(p => {
										return (
											<option key={p.id} value={p.id}>{p.name}</option>
										)
									})}
								</Input>
							</FormGroup>
						</Col>
					</Row>

					{(selectedProperty == null || selectedProperty == "") ? (
						<p className="text-center text-muted">Please select property</p>
					) : null}

					{(selectedProperty && inspections.length === 0) ? (
						<p className="text-center text-muted">No inspections available for this property</p>
					) : null}

					{selectedProperty && inspections.length > 0 ? (
						<Table bordered responsive>
							<thead>
								<tr className="text-center">
									<th></th>
									{selectedIds.map((id, index) => {
										return (
											<th key={index}>Report #{index + 1}</th>
										)
									})}
								</tr>
								<tr className="text-center">
									<td style={{ width: `${100 / (selectedIds.length + 1)}%` }}></td>
									{selectedIds.map((id, index) => {
										return (
											<td key={index} style={{ width: `${100 / (selectedIds.length + 1)}%` }}>
												<Input 
													type="select" 
													value={id} 
													disabled={(viewInspectionId !== null)}
													onChange={(e) => {
														const newReports = [...selectedIds];
														newReports[index] = e.target.value;
														setSelectedIds(newReports);
														getInspectionDetails(e.target.value, index);
													}}
													style={{ width: '250px', margin: '0 auto' }}
												>
													<option value="">- Select Inspection -</option>
													{inspections.map(i => {
														return (
															<option key={i.id} value={i.id}>{i.label}</option>
														)
													})}
												</Input>
											</td>
										)
									})}
								</tr>
								<tr className="text-center">
									<td style={{ width: `${100 / (selectedIds.length + 1)}%` }}></td>
									{selectedInspections.map((inspection, index) => {
										return (
											<td key={index} style={{ width: `${100 / (selectedIds.length + 1)}%` }}>
												{inspection !== null ? (
													<>
													<div className="d-flex align-items-center justify-content-center">
														<IoIosDocument style={{ fontSize: '25px', marginRight: '8px' }} />
														<h4 style={{ margin: '0', fontWeight: 'bold', fontSize: '20px' }}>{formatInspectionActivity(inspection?.activity)}</h4>
														{
															inspection?.is_completed ?
																<h4 style={{ color: 'green', margin: '0', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>Completed</h4>
																:
																<h4 style={{ color: 'red', margin: '0', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>In Progress</h4>

														}
													</div>
													<div className="text-center">{new Date(inspection.inspection_date).toLocaleDateString('en-US')}</div>
													</>
												) : '-'}
											</td>
										)
									})}
								</tr>
								<tr className="text-center">
									<td colSpan={selectedIds.length + 1}>
										<div style={{ display: 'flex', flexWrap: 'wrap' }}>
											<div style={{ flex: '1 1 20%', padding: '0 10px' }}>
												<span style={{ color: '#34b4eb' }}>N= New (just installed or painted)</span>
											</div>
											<div style={{ flex: '1 1 20%', padding: '0 10px' }}>
												<span style={{ color: '#03a631' }}>S= Satisfactory / Acceptable</span>
											</div>
											<div style={{ flex: '1 1 20%', padding: '0 10px' }}>
												<span style={{ color: '#bd060f' }}>D= Existing Damage</span>
											</div>
											<div style={{ flex: '1 1 20%', padding: '0 10px' }}>
												<span style={{ color: '#e6a800' }}>!= Needs attention</span>
											</div>
											<div style={{ flex: '1 1 20%', padding: '0 10px' }}>
												<span style={{ color: '#e68519' }}>N/A= Not Available</span>
											</div>
										</div>
									</td>
								</tr>
							</thead>
							<tbody>
								{(selectedInspections.filter(i => i !== null).length > 0) ? (
									<>
									{selectedInspections.find(i => i !== null)?.areas
										?.sort((a, b) => a.order - b.order)
										?.map((area, areaIndex) => {
											return (
												<>
												<tr key={`area_title_${areaIndex}`} className="text-center">
													<td colSpan={selectedIds.length + 1} style={{ backgroundColor: '#f3f3f3' }}>
														<FaChartArea style={{ fontSize: '15px' }} />
														<strong> {area.sub_title ? `${area.title}: ${area.sub_title}` : `${area.title}`}</strong>
													</td>
												</tr>

												{area.items.map((item, itemIndex) => {
													// #f7cac7
													// #fff4d4
													let bgColor = '#fff4d4';
													let statuses = [];
													selectedInspections.forEach(inspection => {
														let inspItem = inspection?.areas?.find(a => a.area_id === area.area_id)?.items?.find(i => i.item_id === item.item_id);
														if (inspItem) {
															statuses.push(inspItem.status);
														}
													})

													let uniqueStatuses = [...new Set(statuses)];
													let hasDifferentStatus = uniqueStatuses.length > 1;

													if (hasDifferentStatus) {
														// check if uniqueStatuses array contains only NEW and SATISFACTORY 
														let containsOnlyNewAndSatisfactory = uniqueStatuses.every(status => status === 'NEW' || status === 'SATISFACTORY');
														if (containsOnlyNewAndSatisfactory) {
															hasDifferentStatus = false;
														}
													}

													// if (hasDifferentStatus) {
													// 	console.log("Unique Statuses: ", uniqueStatuses);
													// }

													return (
														<tr key={`item_${areaIndex}_${itemIndex}`}>
															<td style={hasDifferentStatus ? { backgroundColor: bgColor } : {}}><strong>{item.name}</strong></td>
															{selectedInspections.map((inspection, inspIndex) => {
																let inspItem = inspection?.areas?.find(a => a.area_id === area.area_id)?.items?.find(i => i.item_id === item.item_id);
																if (!inspItem) {
																	return (
																		<td 
																		key={`${areaIndex}_${itemIndex}_${inspIndex}`}
																		style={hasDifferentStatus ? { backgroundColor: bgColor } : {}}
																		></td>
																	)
																}
																
																return (
																	<td 
																	key={`${areaIndex}_${itemIndex}_${inspIndex}`} 
																	style={hasDifferentStatus ? { backgroundColor: bgColor } : {}}
																	className="text-center"
																	>
																		<div className="d-flex justify-content-center gap-5">
																			{(inspItem.images && inspItem.images.length > 0) ? (
																				<div>
																					<FaImage style={{ fontSize: '20px' }}
																						onClick={() => {
																							setViewItemImage({
																								itemName: item.name,
																								image: inspItem.images[0].image,
																								createdAt: inspItem.images[0].created_at
																							})
																						}}
																					/>
																				</div>
																			) : null}
																			<div>{renderFormattedStatus(inspItem.status)}</div>
																		</div>
																	</td>
																)
															})}
														</tr>
													)
												})}
												</>
											)
										})
									}
									</>
								) : null}
							</tbody>
						</Table>
					) : null}

					{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

					{(viewInspectionId == null) ? (
					<div className='mt-3 text-end'>
						<Button color="primary" type="button" size="lg" onClick={handleSubmit}>Save Comparison Report</Button>
					</div>
					) : null}
				</CardBody>
			</Card>

			{(viewItemImage !== null) ? (
			<Modal isOpen={viewItemImage !== null} toggle={() => setViewItemImage(null)} centered size="lg">
				<ModalHeader toggle={() => setViewItemImage(null)} style={{ display: 'flex', justifyContent: 'space-between' }} close={
					<button className="close" onClick={() => setViewItemImage(null)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
						<FaTimes size={20} />
					</button>
				}>
					<div>{viewItemImage?.itemName}</div>
				</ModalHeader>
				<ModalBody>
					<img
						src={viewItemImage?.image}
						alt={viewItemImage?.itemName}
						style={{ width: '100%' }}
					/>

					<div style={{ marginTop: '15px' }}></div>

					<p><FaCalendar /> {new Date(viewItemImage?.createdAt).toLocaleDateString('en-US')}</p>
				</ModalBody>
			</Modal>
			) : null}
		</div>
	);
}

export default ComparisonReport;
